import styled from 'styled-components';
import IconButton from '../IconButton';
import { colors } from '../theme';

export const ManageUsersButton = styled(IconButton)`
  display: flex;
  color: ${colors('teal')};
  opacity: 0.85;
  margin-bottom: 50px;

  div {
    margin-right: 7px;
    background-color: ${colors('teal')};
  }

  span {
    margin: auto 0;
    font-size: 15px;
    font-weight: 100;
    text-transform: uppercase;
  }

  &:hover {
    color: ${colors('teal')};
    opacity: 1;
    cursor: pointer;

    div {
      background-color: ${colors('teal')};
      opacity: 1;
    }
  }
`;

export const Container = styled.main`
  align-items: center;
  background-color: ${colors('silver')};
  display: flex;
  justify-content: center;
`;

export const Logo = styled.div`
  width: 100px;
  height: 50px;
  margin: 25px auto 25px;
  ::before {
    content: url(${process.env.PUBLIC_URL}/img/logo-full-color.svg);
  }
`;

export const LoginContainer = styled.div`
  align-items: center;
  background-color: ${colors('white')};
  border-radius: 5px;
  box-shadow: 0 4px 4px rgba(155, 185, 195, 0.15);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 50px 100px;
  margin: 20px;
`;

export const CallToAction = styled.button`
  background-color: ${colors('teal')};
  color: ${colors('white')};
  font-weight: bold;
  border: 0;
  border-radius: 3px;
  padding: 14px 24px;
`;

export const UnauthorizedText = styled.p`
  text-align: center;
  line-height: 1.5em;
`;

export const Back = styled.span`
  color: ${colors('teal')};
  display: block;
  text-align: center;
  cursor: pointer;
`;

export const WelcomeText = styled.h2`
  margin-top: 0;
  margin-bottom: 50px;
`;
